<template>
  <v-container>
    <v-row >
      <v-col cols="auto">
        <h2>庫腹占有率計算マスタ一覧</h2>
      </v-col>
      <v-col cols="4" lg="2" class="mt-3">
        <v-select label="12都市区分"
          v-model="searchCondition.selected12City"
          :items="city12List"
          dense 
          :loading="loading"
          :disabled="loading"
          clearable
          @change="loadList()"
        ></v-select>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="1" class="mt-3">
        <v-btn class="btn-font primary" v-on:click="show('', 'new')" :disabled="loading" >
          <v-icon left>mdi-plus-circle</v-icon>
          新規登録
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="items"
      ref="ref"
      :loading="loading"
      :dense='true'
      :items-per-page="10"
      :mobile-breakpoint="0"
      :disable-pagination='true'
      :hide-default-footer='true'
      :hide-default-header='true'
      :fixed-header='true'
      height="calc(100vh - 220px)"
      multi-sort
      locale="ja-jp"
      loading-text="読込中"
      no-data-text="データがありません。"
      class="mt-5"
    >
      <!-- ヘッダー -->
      <template v-slot:header="{ props }">
        <thead>
          <tr>
            <!-- 左側：rowspan 2 -->
            <th rowspan="2" class="text-center" :style="{ width: props.headers[0].width + 'px' }">
              {{ props.headers[0].text }}    <!-- 都市コード -->
            </th>
            <th rowspan="2" class="text-center" :style="{ width: props.headers[1].width + 'px' }">
              {{ props.headers[1].text }}    <!-- 都市名 -->
            </th>

            <!-- 真ん中：比重グループ -->
            <th colspan="10" class="text-center">
              比重
            </th>

            <!-- 右側：rowspan 2（在庫率・操作・余白） -->
            <th rowspan="2" class="text-center" :style="{ width: props.headers[12].width + 'px' }">
              {{ props.headers[12].text }}   <!-- 在庫率 -->
            </th>
            <th rowspan="2" class="text-center" :style="{ width: props.headers[13].width + 'px' }">
              {{ props.headers[13].text }}   <!-- 編集/削除ボタン列 -->
            </th>
          </tr>

          <!-- 2行目：各比重の項目名だけ -->
          <tr>
            <th
              v-for="header in props.headers.slice(2, 12)"
              :key="header.value"
              class="text-center"
            >
              <!-- 項目名 -->
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ item }">
        <tr :key="item.city_code" @dblclick="show(item.city_code, 'edit')">
          <td>
            {{item.city_code}}
          </td>
          <td>
            {{item.city_name}}
          </td>
          <td class="right">
            {{item.weight_seisen}}
          </td>
          <td class="right">
            {{item.weight_reisui}}
          </td>
          <td class="right">
            {{item.weight_enkan}}
          </td>
          <td class="right">
            {{item.weight_suikakou}}
          </td>
          <td class="right">
            {{item.weight_chikusan}}
          </td>
          <td class="right">
            {{item.weight_chikukakou}}
          </td>
          <td class="right">
            {{item.weight_nousan}}
          </td>
          <td class="right">
            {{item.weight_noukakou}}
          </td>
          <td class="right">
            {{item.weight_reisyoku}}
          </td>
          <td class="right">
            {{item.weight_sonota}}
          </td>
          <td class="right">
            {{item.rate_stock}}
          </td>

          <td class="center px-0" >
            <v-btn small class="mx-1 btn-font primary" v-on:click='show(item.city_code, "edit")'
                :height="20" :width="50" :disabled="loading">
              <v-icon :small="true">mdi-border-color</v-icon>
              編集
            </v-btn>
            <v-btn small class="mx-1 ml-5 btn-font secondary" v-on:click='show(item.city_code, "delete")'
                :height="20" :width="50" :disabled="loading">
              <v-icon :small="true">mdi-delete</v-icon>
              削除
            </v-btn>
          </td>
        </tr>
      </template>

    </v-data-table>

    <!-- modal -->
    <modal name="modal-dialog" :draggable="false" :clickToClose="false" :scrollable="true" 
                                height="auto" width="80%" id="vm--modal">
      <div >
        <!-- <div class="modal-header mt-5">
          <h2>会社編集</h2>
        </div> -->
        <div class="modal-body">
          <MstorageOccupancyRateEdit v-on:closeEvt="hide" :mode="mode" :targetCityCode="targetCityCode" :masterDataList="items" />
        </div>
      </div>
    </modal>

  </v-container>

</template>

<script>
import MstorageOccupancyRate from '../../model/m_storage_occupancy_rate';
import MstorageOccupancyRateEdit from './MstorageOccupancyRateEdit';

import M12city from "../../model/m_12_city";

import Message from '../../Lib/Message';
import Debug from '../../Lib/Debug';

import Mixin from "../../mixins/const.js";

export default {
  mixins: [Mixin],
  
  components: {
    MstorageOccupancyRateEdit,
  },

  data: () => ({
    loading: false,

    headers: [
      { text: '都市コード', align: 'left', sortable: true, value: 'city_code', width: 120 },
      { text: '都市名', align: 'left', sortable: true, value: 'city_name', width: 150 },
      { text: '生鮮水産物', align: 'left', sortable: true, value: 'weight_seisen', width: 120 },
      { text: '冷凍水産物', align: 'left', sortable: true, value: 'weight_reisui', width: 120 },
      { text: '塩干水産物', align: 'left', sortable: true, value: 'weight_enkan', width: 120 },
      { text: '水産加工品', align: 'left', sortable: true, value: 'weight_suikakou', width: 120 },
      { text: '畜産物', align: 'left', sortable: true, value: 'weight_chikusan', width: 120 },
      { text: '畜産加工品', align: 'left', sortable: true, value: 'weight_chikukakou', width: 120 },
      { text: '農産物', align: 'left', sortable: true, value: 'weight_nousan', width: 120 },
      { text: '農産加工品', align: 'left', sortable: true, value: 'weight_noukakou', width: 120 },
      { text: '冷凍食品', align: 'left', sortable: true, value: 'weight_reisyoku', width: 120 },
      { text: 'その他', align: 'left', sortable: true, value: 'weight_sonota', width: 120 },
      { text: '実運用時\n最大収容可能\n容積率', align: 'left', sortable: true, value: 'rate_stock', width: 120 },
      { text: '', align: 'center', sortable: false, value: 'action', width: 300 },
    ],

    items: [],

    searchCondition: {
      screenType: 'MstorageOccupancyRateList',
      enable: false,
      selected12City: null,
    },

    // edit用
    mode: '',
    targetCityCode: null,

    // 12都市区分リスト
    city12List: [],
  }),

  // ライフサイクルフック
  created: function () {
  },

  mounted: async function () {
    const storeSearchCondition = this.$store.getters.getStoreSearchCondition;
    if (storeSearchCondition.screenType == 'MstorageOccupancyRateList') {
      this.searchCondition = storeSearchCondition;
    }
    Debug.log2("searchCondition", this.searchCondition);

    // v-select のデータを非同期で取得
    this.loading = true;
    const promiseArray = [];
    promiseArray.push(this.getCity12List());
    Promise.all(promiseArray);

    await this.loadList();
    this.loading = false;
  },

  methods: {
    async getCity12List() {
      Debug.log("function[getCity12List]");
      // DBから12都市情報取得
      M12city.selectList()
          .then(res => {
            if (res.data) {
              this.city12List = res.data;

              // 先頭に全体を追加
              this.city12List.unshift({text: '全体', value: '000'});

              Debug.log(this.city12List);
            }
          })
          .catch (err => {
            Message.err(err, "12都市区分を取得できませんでした");
          });
    },

    async loadList() {
      Debug.log("function[loadList]");

      this.loading = true;

      // DBから庫腹占有率計算マスタ一覧取得
      try {
        const res = await MstorageOccupancyRate.search(this.searchCondition);
        this.items = res.data;

        this.$store.commit('setStoreSearchCondition', this.searchCondition);
      } catch (error) {
        Message.err(error, "庫腹占有率計算マスタ一覧データを取得できませんでした");
      }

      this.loading = false;

      Debug.log(this.items);
    },

    // モーダル表示用
    show (editid, mode) {
      Debug.log('function[show]');
      this.mode = mode;
      this.targetCityCode = editid; 

      Debug.log('edit mode : ' + mode);
      Debug.log('disp CityCode : ' + editid);

      this.$modal.show('modal-dialog');
    },
    hide : function () {
      Debug.log('function[hide]');
      this.$modal.hide('modal-dialog');

      // TABLEを読み直す
      this.loadList();
    },

    updateEvt () {
      Debug.log('function[updateEvt]');

      this.hide();
    },

  },

  computed: {
  },

}

</script>


<style scoped>

.v-data-table table {
  width: initial !important;
}

.v-data-table table th {
  font-size: 12pt;
}

.v-data-table table td {
  font-size: 11pt;
}

/* modal dialog */
.modal-header, .modal-body {
  padding: 5px 25px;
}
.modal-header {
  border-bottom: 1px solid #ddd;
}

.vm--modal {
  min-width: 400px;
  max-width: 600px;
}

.btn-font {
  color: white;
}

.v-text-field {
  padding-top: 2px;
  padding-bottom: 2px;
  margin-top: 4px;
  margin-bottom: 4px;
}

th {
  white-space: pre-line;
}

.v-input--radio-group {
  margin: 0;
}

</style>
